import { db } from "./index";
import { ref, set, child, get } from "firebase/database";
const userId = localStorage.getItem("userId");
const dbRef = ref(db);

export const sendData = (products) => {
  set(ref(db, `selectedProducts/${userId}`), products);
};

export async function getData() {
  try {
    let snapshot = await get(child(dbRef, `selectedProducts/${userId}`));

    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      console.log("No data available");
      return;
    }
  } catch (e) {
    // error
    console.log(e);
  }
}